import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import { SelectActivityTypeTag } from "../../../../Tags/shared/SelectActivityTypeTag.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/ActivityTypes/Form.tsx
var ActivityTypesFieldForm = ({ config }) => {
	const { errorsByFieldId, fieldValueChanged, valuesByFieldId } = useFormBuilderFieldsContext();
	return /* @__PURE__ */ jsx(SelectActivityTypeTag, {
		allowCreate: config.options.allowCustomTags,
		error: errorsByFieldId[config.id],
		hint: /* @__PURE__ */ jsxs(Fragment$1, { children: [config.options.required && /* @__PURE__ */ jsx("span", {
			className: "text-color-critical text-sm font-light",
			children: "Required"
		}), config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {})] }),
		isClearable: true,
		multi: true,
		label: /* @__PURE__ */ jsx(Fragment$1, { children: config.options.label || config.options.formLabel }),
		onChangeOptions: (val) => fieldValueChanged(config.id, val),
		value: valuesByFieldId[config.id],
		name: config.name,
		subText: config.options.subText
	});
};
//#endregion
export { ActivityTypesFieldForm };

//# sourceMappingURL=Form.js.map